/**
 *
 * Asynchronously loads the component for MyAssetsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const MyAssetsPage = lazyLoad(
  () => import('./index'),
  module => module.MyAssetsPage,
);
